import { apiClient } from './apiClient';

const safePath = () => (typeof window !== 'undefined' ? window.location.pathname : '/');

export const recordViewEvent = (event = {}) => {
    const payload = {
        eventType: event.eventType,
        viewMode: event.viewMode,
        path: event.path || safePath(),
        direction: event.direction || undefined,
        errorName: event.errorName || undefined,
    };
    return apiClient.post('/view-events', payload).catch(() => null);
};

export default recordViewEvent;

